import type { DirectoryGroupCard } from './api';
import type { Group } from './types';

/**
 * Derive a short reference prefix from a group name.
 *
 * Multi-word names: first letter of each word (e.g., "Fire Safety Group" -> "FSG").
 * Names under 5 characters: use the whole name (e.g., "HR" -> "HR").
 *
 * Mirrors the backend logic in groups/models.py.
 */
export function deriveShortReference(groupName: string): string {
  const name = groupName.trim();
  if (name.length < 5) return name.toUpperCase();
  const words = name.split(/\s+/).filter(Boolean);
  return words
    .map((w) => w[0])
    .join('')
    .toUpperCase();
}

/** Adapt a group directory card to the `Group` shape; fields the card lacks are blank. */
export function directoryCardToGroup(card: DirectoryGroupCard): Group {
  return {
    id: card.group_id,
    tenant: '',
    tenant_name: '',
    name: card.name,
    short_reference: '',
    description: card.description,
    type: card.type,
    visibility: card.visibility,
    created_by_id: null,
    user_permission: card.user_permission ?? 0,
    created_at: '',
    updated_at: card.updated_at,
    populate: { populate_stage: 'intro', completed_stages: [], populate_completed_at: null },
    safety_group:
      card.type === 'safety' ? { domain: card.domain as Group['domain'], terms_of_reference_id: null } : null,
    domain: card.domain as Group['domain']
  };
}
